<template>
  <div class="bundling">
    <div class="requiredInfo font-size-12">
      <!-- 提示语 -->
      <div class="title flex items-center flex-start q-px-md">
        <span v-if="hasRequireModifiers" bold class="subTitle">
          {{ $t('details.chooseVariant') }}
        </span>
        <span v-else bold class="q-mx-xs subTitle text-black">
          {{ $t('details.hasModifiers') }}
        </span>
        <span v-if="hasRequireModifiers" class="q-mx-xs required">
          {{ $t('details.required') }}
        </span>
      </div>
      <div class="option bg-white">
        <q-card
          v-for="(item, index) in baseGroup.members"
          :key="item.id"
          flat
          class="productOption q-mb-sm q-pa-md"
          :class="{ errorTips: !item.isVerify }"
        >
          <q-card-section class="q-pa-none q-mb-sm base-item-r1">
            <span bold class="ellipsis-2-lines r1-name">
              {{ item.product.name }}
            </span>
            <div class="r1-right">
              <div
                v-if="showTips(item) && !(item.params && item.params.length)"
                class="r1-right-tip"
              >
                <span v-if="item.isVerify">*</span>
                <span v-else>
                  <q-icon name="error" size="16px" />
                </span>
                <span class="q-ml-xs">{{ $t('details.pleaseSelect') }}</span>
              </div>
              <span class="text-theme-gray qty">QTY: {{ item.quantity }}</span>
            </div>
          </q-card-section>
          <q-card-section class="q-pa-none q-mb-sm">
            <div
              v-for="obj in item.params || []"
              :key="`${obj.modifierItemId}-${obj.modifierOptionId}`"
              class="text-theme-gray"
            >
              . {{ obj.name }}
            </div>
            <div v-if="item.comment" break class="text-theme-gray">
              {{ item.comment }}
            </div>
          </q-card-section>
          <q-card-actions align="between" class="q-pa-none">
            <span
              v-if="item.params && item.params.length"
              class="text-theme-gray"
            >
              +
              {{ $n(item.modifierPrice * item.quantity, 'currency', 'id-ID') }}
            </span>
          </q-card-actions>
          <q-card-section class="base-item-action">
            <div class="action-item" @click="onAddNotes(item)">
              <i
                class="iconfont"
                :class="[item.comment ? 'dm-a-Pencilalt' : 'dm-a-Xcircle']"
              />
              {{
                item.comment ? $t('details.editNotes') : $t('details.addNotes')
              }}
            </div>
            <div
              v-if="item.product.modifiers"
              class="action-item"
              @click="handlerShowSelect(item, index)"
            >
              <i
                class="iconfont"
                :class="[
                  item.params && item.params.length
                    ? 'dm-a-Pencilalt'
                    : 'dm-a-Xcircle',
                ]"
              />
              {{
                item.params && item.params.length
                  ? $t('details.editVariant')
                  : $t('details.selectVariant')
              }}
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <Dialog
      v-model="showSelect"
      :modifiers="modifiers"
      @getParams="getModiParams"
    />
    <CommentDialog :value="activeComment" @input="onConfirmComment" />
  </div>
</template>

<script>
import _ from 'lodash';
import { expandArr } from 'src/utils/loadsh';
import { verify } from './units';
import Dialog from './BaseDialog.vue';
import CommentDialog from './CommentDialog.vue';

export default {
  components: { Dialog, CommentDialog },
  model: {
    prop: 'baseParams',
    event: 'getBaseParams',
  },
  props: {
    original: {
      type: Object,
      default: () => {},
    },
    baseParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hasRequireModifiers: true,
      baseGroup: {},
      modifiers: [],
      showSelect: false,
      curIndex: 0,
      activeComment: {
        productId: '',
        comment: '',
      },
    };
  },
  watch: {
    original: {
      handler(val) {
        if (!_.isEmpty(val)) {
          val.members.forEach((item) => {
            item.isVerify = true;
            item.modifierPrice = 0;
          });
          // 克隆数据 以便改动
          this.baseGroup = _.cloneDeep(val);
          this.hasRequireModifiers = this.checkRequired().some((it) => !it);
        }
      },
      immediate: true,
      deep: true,
    },
    baseGroup: {
      handler(val) {
        if (!_.isEmpty(val)) {
          // 拼接返回参数
          const params = {
            packageGroupId: val.groupId,
            items: [],
          };
          val.members.forEach((item) => {
            const obj = {
              type: 'single',
              productId: item.product.id,
              quantity: item.quantity || 1,
              comment: item.comment,
              modifiers: item.params || [],
            };
            params.items.push(obj);
          });
          this.$emit('getBaseParams', params);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handlerShowSelect(item, index) {
      this.modifiers = item.product.modifiers;
      this.curIndex = index;
      this.showSelect = true;
    },
    getModiParams(val) {
      const obj = this.baseGroup.members[this.curIndex];
      const params = expandArr(val);
      let price = 0;
      params.forEach((item) => {
        price += item.price;
      });
      obj.modifierPrice = price;
      this.$set(obj, 'params', params);
      obj.isVerify = true;
      val.forEach((item, index) => {
        this.$set(obj.product.modifiers[index], 'value', item);
      });
    },
    checkRequired() {
      const { members = [] } = this.baseGroup;
      const result = members.map((item) => {
        const { modifiers } = item.product;
        if (modifiers) {
          item.isVerify = verify(modifiers);
          return verify(modifiers);
        }
        item.isVerify = true;
        return true;
      });
      return result;
    },
    showTips(detail) {
      const { modifiers } = detail.product;
      if (modifiers) {
        return modifiers.some((item) => item.min > 0);
      }
      return false;
    },
    onAddNotes(product) {
      this.activeComment = {
        comment: product.comment,
        productId: product.product.id,
      };
    },
    onConfirmComment(_comment) {
      const { comment, productId } = _comment;
      this.baseGroup.members.find((it) => {
        if (it.product.id === productId) this.$set(it, 'comment', comment);
        this.activeComment = { productId: '', comment: '' };
        return it.product.id === productId;
      });
    },
  },
};
</script>

<style lang="scss">
.bundling {
  .requiredInfo {
    .title {
      padding: 8px 16px;
      line-height: 24px;
    }
    .required {
      height: 16px;
      line-height: 16px;
      background: $primary;
      padding: 0 4px;
      border-radius: 2px;
      color: #ffffff;
    }
    .option {
      padding: 10px 16px 8px;
      .productOption.errorTips {
        background: #fef2f2;
      }
      .q-card {
        border-radius: 8px;
        border: solid 1px $border-color-3;
        &:last-child {
          margin-bottom: 0;
        }
        .errTips {
          color: $negative;
        }
      }
    }
  }
  .productOption {
    position: relative;
    padding-bottom: 40px;
    overflow: hidden;
  }
  // ====
  .base-item {
    &-r1 {
      display: flex;
      align-items: center;
      .r1-name {
        font-size: 14px;
        align-self: flex-start;
      }
      .r1-right {
        min-width: 90px;
        margin-left: auto;
        text-align: right;
        font-size: 12px;
        color: $negative;
        &-tip {
          margin-bottom: 4px;
        }
      }
      .qty {
        margin-left: auto;
      }
    }
    &-action {
      display: flex;
      justify-content: space-around;
      padding: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: $button-bg;
      border-top: solid 1px $border-color-3;
      font-weight: bold;
      .action-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        .iconfont {
          color: #6b7280;
          margin-right: 3px;
        }
      }
    }
    .comment {
      color: $grayFont;
    }
  }
}
</style>
